import { Anchor, IconButton, Paragraph, Tooltip } from '@zillow/constellation-10';
import { IconInfoOutline } from '@zillow/constellation-icons';

const FAIR_HOUSING_ACCESSIBILITY_URL = 'https://www.hud.gov/helping-americans/disabilities';

const DisabledAccessAmenityTooltip = () => (
  <Tooltip.Root placement="top">
    <Tooltip.Trigger>
      <IconButton
        aria-label="Learn more about Disabled access"
        emphasis="bare"
        shape="circle"
        size="md"
        title="More information"
        tone="brand"
        icon={<IconInfoOutline />}
        css={{
          height: 'auto',
          minHeight: 'unset',
          padding: 0,
          backgroundColor: 'transparent',
          flexShrink: 0,
          alignSelf: 'center',
        }}
      />
    </Tooltip.Trigger>
    <Tooltip.Portal>
      <Tooltip.Content>
        <Paragraph css={{ fontWeight: 'normal' }}>
          Select this if your property adheres to the{' '}
          <Anchor href={FAIR_HOUSING_ACCESSIBILITY_URL} target="_blank" rel="noopener noreferrer">
            Fair Housing Act Accessibility Requirements
          </Anchor>
          , or other similar design standard. If you&apos;re not sure if your rental meets those requirements, it&apos;s
          best to leave &quot;Disabled access&quot; unchecked and describe any accessibility features in the listing
          description.
        </Paragraph>
        <Tooltip.Arrow />
      </Tooltip.Content>
    </Tooltip.Portal>
  </Tooltip.Root>
);

export default DisabledAccessAmenityTooltip;
